import {
    Component,
    OnInit,
    Input,
    HostBinding,
    HostListener
} from '@angular/core';
import {
    Router,
    NavigationEnd
} from '@angular/router';

import { filter, tap } from 'rxjs/operators';

@Component({
    selector: 'app-subscription-token',
    templateUrl: './subscription-token.component.pug',
    styleUrls: ['./subscription-token.component.less']
})
export class SubscriptionTokenComponent implements OnInit {

    @HostBinding('class.btn--striped') isLoading: boolean;

    @Input() shard;
    @Input() color;
    @Input() data;
    @Input() resource = '';

    @HostListener('click')
    onClick(): void {
        this.isLoading = true;

        const navigationEnd$ = this._router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .pipe(tap((data) => this.isLoading = false))
            .subscribe(() => navigationEnd$.unsubscribe());
    }

    get hasPrice() {
        return this.data.hasOwnProperty('avgPrice');
    }

    constructor(
        private _router: Router
    ) { }

    ngOnInit() {
    }

}
